"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "56.33 457.15 2387.34 1585.74",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsxs)("linearGradient", {
      id: "a",
      gradientTransform: "matrix(1 0 0 -1 0 2500)",
      gradientUnits: "userSpaceOnUse",
      x1: 573.85,
      x2: 2217.65,
      y1: 1291.09,
      y2: 1208.07,
      children: [(0, _jsxRuntime.jsx)("stop", {
        offset: 0,
        stopColor: "#0064e1"
      }), (0, _jsxRuntime.jsx)("stop", {
        offset: 0.4,
        stopColor: "#0064e1"
      }), (0, _jsxRuntime.jsx)("stop", {
        offset: 0.83,
        stopColor: "#0073ee"
      }), (0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#0082fb"
      })]
    }), (0, _jsxRuntime.jsxs)("linearGradient", {
      id: "b",
      gradientTransform: "matrix(1 0 0 -1 0 2500)",
      gradientUnits: "userSpaceOnUse",
      x1: 400.24,
      x2: 400.24,
      y1: 888.86,
      y2: 1494.91,
      children: [(0, _jsxRuntime.jsx)("stop", {
        offset: 0,
        stopColor: "#0082fb"
      }), (0, _jsxRuntime.jsx)("stop", {
        offset: 1,
        stopColor: "#0064e0"
      })]
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M314.19 1502.88c0 91.16 20 161.14 46.16 203.48 34.29 55.46 85.43 79 137.57 79 67.24 0 128.76-16.69 247.31-180.66 95-131.42 206.89-315.89 282.19-431.54l127.52-195.93c88.58-136.07 191.11-287.33 308.67-389.86 96-83.69 199.5-130.18 303.69-130.18 174.93 0 341.55 101.37 469.07 291.49 139.56 208.21 207.3 470.48 207.3 741.12 0 160.9-31.71 279.12-85.68 372.52-52.13 90.32-153.75 180.57-324.69 180.57v-257.57c146.37 0 182.89-134.5 182.89-288.42 0-219.34-51.14-462.75-163.8-636.68-79.94-123.37-183.55-198.75-297.54-198.75-123.29 0-222.5 93-334 258.77-59.28 88.09-120.13 195.43-188.46 316.56l-75.22 133.25C1006.09 1638 967.81 1699 892.26 1799.68 759.85 1976 646.77 2042.85 497.92 2042.85c-176.59 0-288.25-76.47-357.41-191.7-56.45-93.89-84.18-217.1-84.18-357.48z",
      fill: "#0081fb"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M259.65 766.82c118.22-182.23 288.83-309.67 484.51-309.67 113.32 0 226 33.54 343.62 129.6 128.68 105 265.83 278 436.94 563l61.35 102.25c148.11 246.74 232.37 373.68 281.69 433.54 63.42 76.87 107.84 99.79 165.54 99.79 146.37 0 182.89-134.5 182.89-288.42l227.48-7.14c0 160.9-31.71 279.12-85.68 372.52-52.13 90.32-153.75 180.57-324.69 180.57-106.27 0-200.41-23.08-304.52-121.3-80-75.38-173.6-209.29-245.58-329.67l-214.11-357.65c-107.42-179.49-206-313.32-263-373.93C944.73 795.13 865.86 716.43 740 716.43c-101.86 0-188.37 71.48-260.76 180.82z",
      fill: "url(#a)"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M740 716.43c-101.86 0-188.37 71.48-260.76 180.82-102.37 154.5-165 384.63-165 605.63 0 91.16 20 161.14 46.16 203.48l-219.89 144.79c-56.45-93.89-84.18-217.1-84.18-357.48 0-255.29 70.07-521.37 203.32-726.85 118.22-182.23 288.83-309.67 484.51-309.67z",
      fill: "url(#b)"
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Meta.js.map